import { privateAPI } from "@/shared/lib";
import type { ServiceResponse } from "@/shared/lib/axios";
import type { Patient } from "@/shared/models/legacy-types";

export const getPatient = async () => {
  const { data } = await privateAPI.get<ServiceResponse<Patient>>(`/patients`);

  return data.data;
};
